import src from "IMAGE";
export default { src, width: 138, height: 162, blurWidth: 0, blurHeight: 0};
